<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 offset-sm3 sm6 offset-lg4 lg4>
        <v-card class="text-xs-center">
          <v-card-text>
            <v-progress-circular indeterminate />
            <v-spacer/>
            <v-flex>
              <h2>One moment please...</h2>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import {
  FETCH_USER_ANNOUNCEMENTS,
  GET_ENGAGEMENT_LAST_SUCCESSFUL,
  GET_DROPDOWN_VALUES,
  LOGIN_SSO_ACTION
} from '../../store/action-types'
import { IS_STUDENT } from '../../store/getter-types'

export default {
  name: 'login-sso',
  props: [],
  data () {
    return {}
  },
  computed: {
    ...mapState({
      redirectTokenName: state => state.config.redirectTokenName,
      loggedInUsername: state => state.profile.username,
      categories: state => state.intervention.categories
    }),
    ...mapGetters({
      isStudent: IS_STUDENT
    })
  },
  watch: {
    loggedInUsername (name) {
      if (name) {
        if (this.categories.length === 0) { // load values if not yet loaded
          this.$store.dispatch(GET_DROPDOWN_VALUES)
        }
        this.fetchAnnouncements()
        this.getEngagementLastSuccessful()
        this.loggedIn()
      }
    }
  },
  methods: {
    loginWithSSO (token) {
      if (token) {
        this.loginSSOAction(token)
      } else {
        this.$router.push('/login')
      }
    },
    loggedIn () {
      let name = (this.isStudent) ? 'StudentHome' : 'Dashboard'
      this.$router.push({name})
    },
    ...mapActions({
      loginSSOAction: LOGIN_SSO_ACTION,
      fetchAnnouncements: FETCH_USER_ANNOUNCEMENTS,
      getEngagementLastSuccessful: GET_ENGAGEMENT_LAST_SUCCESSFUL
    })
  },
  mounted () {
    this.loginWithSSO(this.$route.query[this.redirectTokenName])
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/login/LoginSSO.vue